import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=2385def4&"
var script = {}
import style0 from "./_base-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports